module.exports = __webpack_public_path__ + "static/media/adds.7352af3c.jpg";